export default "__VITE_ASSET__51dbffed__"